<script lang="ts" setup>
	export type VoidInspectionContext = {
		pagePath?: string
		QrCodeLink?: string
		title: string
		key?: string
		subTitle?: string
		useReturnPath?: boolean
	}

	const props = defineProps<{
		show: boolean
		/** @description This Props helps to navigate and show the right title of which inspection you are doing */
		urlProps: VoidInspectionContext
		cancelBtn?: boolean
	}>()
	const emit = defineEmits<{
		(event: 'update:show', param: boolean): void
		(event: 'proceed'): void
	}>()

	const openInspectionPage = async () => {
		const { QrCodeLink, title, subTitle, pagePath } = props.urlProps
		emit('update:show', false)
		await navigateTo({
			path: pagePath || '/inspection-scanner',
			query: {
				inspection: encryptData({
					QrCodeLink,
					title,
					subTitle: subTitle || "Important key to-do's you need to know about the next steps"
				})
			}
		})
	}
</script>

<template>
	<dialogs-error
		:show="show"
		type="warning"
		header="Platform Compatibility"
		wrapper-class="bg-gray-50 text-gray-600 p-8 rounded"
		modal-button-text="Continue"
		:use-cancel-btn="!cancelBtn"
		@done="openInspectionPage"
		@close="emit('update:show', false)"
	>
		<template #paragraph>
			<div class="mt-5">
				<slot name="description">
					It seems that you are attempting to carry out an inspection on your desktop. Please note that
					inspections can only be done using your <span class="font-medium">mobile phone</span> .

					<br />
					<br />
					Click continue button to proceed to scan a QR code with your mobile phone or request an inspection
					link to your email.
				</slot>
			</div>
		</template>
	</dialogs-error>
</template>
